import React, { useEffect, useState } from 'react';
import Icon from '../AppIcon';

const CONFETTI_COLORS = ['#7E6BC4', '#A78BFA', '#C4B5FD', '#EDE9FE', '#FBBF24', '#34D399', '#F472B6'];

function Particle({ color, delay }) {
  const left = Math.random() * 100;
  const size = 4 + Math.random() * 6;
  const duration = 1.5 + Math.random() * 1.5;
  const drift = -30 + Math.random() * 60;

  return (
    <div
      className="absolute rounded-sm opacity-0"
      style={{
        left: `${left}%`,
        top: '-5%',
        width: size,
        height: size * (0.6 + Math.random() * 0.8),
        backgroundColor: color,
        animation: `confetti-fall ${duration}s ease-out ${delay}s forwards`,
        '--drift': `${drift}px`,
      }}
    />
  );
}

const UpgradeSuccessModal = ({ isOpen, onClose }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    const p = [];
    for (let i = 0; i < 60; i++) {
      p.push({
        id: i,
        color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
        delay: Math.random() * 0.8,
      });
    }
    setParticles(p);
  }, [isOpen]);

  if (!isOpen) return null;

  const features = [
    { icon: 'Sparkles', text: 'Unlimited AI generations' },
    { icon: 'Send', text: 'Unlimited publishes' },
    { icon: 'ImagePlus', text: 'Image attachments' },
    { icon: 'BarChart3', text: 'Analytics dashboard' },
    { icon: 'Palette', text: 'Unlimited writing styles' },
  ];

  return (
    <div className="fixed inset-0 z-[3000] flex items-center justify-center">
      <style>{`
        @keyframes confetti-fall {
          0% { opacity: 1; transform: translateY(0) translateX(0) rotate(0deg); }
          100% { opacity: 0; transform: translateY(85vh) translateX(var(--drift)) rotate(${360 + Math.random() * 360}deg); }
        }
        @keyframes pop-in {
          0% { opacity: 0; transform: scale(0.8); }
          50% { transform: scale(1.03); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" />

      {/* Confetti layer */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {particles.map(p => (
          <Particle key={p.id} color={p.color} delay={p.delay} />
        ))}
      </div>

      {/* Modal */}
      <div
        className="relative w-full max-w-md mx-4 bg-background border border-border rounded-2xl shadow-2xl overflow-hidden"
        style={{ animation: 'pop-in 0.4s ease-out forwards' }}
      >
        {/* Purple gradient header */}
        <div className="bg-gradient-to-r from-[#7E6BC4] to-[#A78BFA] px-6 py-8 text-center">
          <div className="text-5xl mb-3">🎉</div>
          <h2 className="text-xl font-bold text-white mb-1">Welcome to Pro!</h2>
          <p className="text-sm text-white/80">All features are now unlocked</p>
        </div>

        {/* Features */}
        <div className="px-6 py-5 space-y-3">
          {features.map((f, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-7 h-7 rounded-lg bg-violet-500/10 flex items-center justify-center flex-shrink-0">
                <Icon name={f.icon} size={14} className="text-violet-400" />
              </div>
              <span className="text-sm text-foreground">{f.text}</span>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="px-6 pb-6">
          <button
            onClick={onClose}
            className="w-full py-2.5 bg-gradient-to-r from-[#7E6BC4] to-[#A78BFA] text-white font-semibold text-sm rounded-lg hover:opacity-90 transition-all"
          >
            Start Creating
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpgradeSuccessModal;
